<template>
  <v-dialog v-model="show" max-width="648">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.INVOICES') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <ul style="list-style: none;" class="pl-0">
          <li v-for="invoice in invoices" :key="invoice.Url">
            <!-- <span class="caption">{{ invoice.Type }}</span> -->
            <v-icon v-if="invoice.Sent" color="success" class="mr-2">
              mdi-check
            </v-icon>
            <a style="color: #007CAD;" :href="invoice.Url" target="_blank">{{
              invoice.Url
            }}</a>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InvoicesDialog',
  props: {
    sessionId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      invoices: []
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.invoices = []
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.$store
      .dispatch('sessions/getSessionInvoices', this.sessionId)
      .then(invoices => {
        this.invoices = invoices
      })
  }
}
</script>
